export default __webpack_public_path__ + "427f7bc5ee7fd277a662a45ad8d36233.svg";